import { get, post, serialize } from '../httpClient';

export const communityAPI = {
  posts: {
    addCount: body => post('/api/community/posts/add-count', serialize(body)),
  },
  comments: {
    create: body => post('/api/community/comments/create', serialize(body)),
    update: body => post('/api/community/comments/update', serialize(body)),
    delete: body => post('/api/community/comments/delete', serialize(body)),
    addCount: body => post('/api/community/comments/add-count', serialize(body)),
  },
  userActivity: params => get('/api/community/user-activity', params),
};